/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OAuth2TokenResponse
 */
export interface OAuth2TokenResponse {
    /**
     * 
     * @type {string}
     * @memberof OAuth2TokenResponse
     */
    token: string;
    /**
     * 
     * @type {string}
     * @memberof OAuth2TokenResponse
     */
    accessToken: string;
    /**
     * 
     * @type {number}
     * @memberof OAuth2TokenResponse
     */
    expiresIn: number;
    /**
     * 
     * @type {string}
     * @memberof OAuth2TokenResponse
     */
    idToken: string;
    /**
     * 
     * @type {string}
     * @memberof OAuth2TokenResponse
     */
    refreshToken: string;
    /**
     * 
     * @type {string}
     * @memberof OAuth2TokenResponse
     */
    tokenType: string;
}

/**
 * Check if a given object implements the OAuth2TokenResponse interface.
 */
export function instanceOfOAuth2TokenResponse(value: object): value is OAuth2TokenResponse {
    if (!('token' in value) || value['token'] === undefined) return false;
    if (!('accessToken' in value) || value['accessToken'] === undefined) return false;
    if (!('expiresIn' in value) || value['expiresIn'] === undefined) return false;
    if (!('idToken' in value) || value['idToken'] === undefined) return false;
    if (!('refreshToken' in value) || value['refreshToken'] === undefined) return false;
    if (!('tokenType' in value) || value['tokenType'] === undefined) return false;
    return true;
}

export function OAuth2TokenResponseFromJSON(json: any): OAuth2TokenResponse {
    return OAuth2TokenResponseFromJSONTyped(json, false);
}

export function OAuth2TokenResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OAuth2TokenResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'],
        'accessToken': json['access_token'],
        'expiresIn': json['expires_in'],
        'idToken': json['id_token'],
        'refreshToken': json['refresh_token'],
        'tokenType': json['token_type'],
    };
}

export function OAuth2TokenResponseToJSON(json: any): OAuth2TokenResponse {
    return OAuth2TokenResponseToJSONTyped(json, false);
}

export function OAuth2TokenResponseToJSONTyped(value?: OAuth2TokenResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'token': value['token'],
        'access_token': value['accessToken'],
        'expires_in': value['expiresIn'],
        'id_token': value['idToken'],
        'refresh_token': value['refreshToken'],
        'token_type': value['tokenType'],
    };
}

